<template>
  <div class="page-content">
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
        <h4 class="h4-white">Termo de Responsabilidade</h4>
      </div>
      <div
        class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-between justify-content-md-end"
      >
        <div class="actions actions-dark d-inline-block">
          <a href="#" @click="getPageLista()" class="action-item ml-md-4 text-white btn">
            <i class="oi oi-grid-three-up mr-2"></i>Lista
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermoResponsabilidadeActions",
  methods: {
    getPageLista: function() {
      this.$router.push("/TermoResponsabilidadeLista");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/termoResponsabilidade/TermoResponsabilidadeActions.vue